export enum Unit {
    Electricity = 'kwh',
}
